
const BootstrapIcon = ({ name, className = '', ...props }) => {
  if (!name) {
    return null; // Si no se proporciona un nombre, no renderiza nada
  }
  return <i className={`text-light fs-5 bi bi-${name} ${className}`.trim()} {...props}></i>;
};

const InfoCard = ({ label, value, variant='midgray', title, icon_name='', unit, inline = false }) => {

  return (
    <span className={`info-card ${variant} my-0 px-1 py-0`} title={`${title}`}>
      <span className="info-title text-center text-light text-opacity-50 p-0">{label} {} <BootstrapIcon name={icon_name} /></span>
      {!inline ? <br /> : null}
      <span className="info-value fs-6">{value}</span> <span className="info-unit text-light text-opacity-50">{unit}</span>
    </span>
  );
};

export default InfoCard;
